import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

const initialState = {
  clientMeta: {
    name: '',
    age: 0,
    investments: 100000,
  },
  stages: [{ id: 1, date: moment(), objective: 'Current Day', goal: null, shape: 'circle', color: 'blue' }],
};

const clientJourneySlice = createSlice({
  name: 'clientJourney',
  initialState,
  reducers: {
    addStage: (state, action) => {
      state.stages.push(action.payload);
    },
    updateStage: (state, action) => {
      const index = state.stages.findIndex(stage => stage.id === action.payload.id);
      if (index !== -1) {
        state.stages[index] = action.payload;
      }
    },
    updateClientMeta: (state, action) => {
      state.clientMeta = action.payload;
    },
  },
});

export const { addStage, updateStage, updateClientMeta } = clientJourneySlice.actions;

export default clientJourneySlice.reducer;
